if (!customElements.get('rw-plan-comparison')) {
  customElements.define('rw-plan-comparison', class extends HTMLElement {
    connectedCallback() {
      if (this.events && !this.events.signal.aborted) return;
      this.events = new AbortController();
      const picker = this.querySelector('.rw-period-picker');
      if (!picker) return;
      picker.hidden = false;
      this.select(this.period || 'first');
      picker.addEventListener('click', event => {
        const button = event.target.closest('[data-plan-period]');
        if (button) this.select(button.dataset.planPeriod);
      }, { signal: this.events.signal });
    }
    select(period) {
      if (!['first', 'second'].includes(period)) return;
      this.period = period;
      this.querySelectorAll('[data-plan-option]').forEach(panel => { panel.hidden = panel.dataset.planOption !== period; });
      this.querySelectorAll('[data-plan-period]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.planPeriod === period)));
    }
    disconnectedCallback() {
      queueMicrotask(() => { if (!this.isConnected) this.events?.abort(); });
    }
  });
}
